exports.colors = {
    primary : "#007feb",
    primaryHi : "#BCE0FD",
    midGrey : "#999999",
    hiGrey: "#e4e4e4",
    dark : "#333333"
}
/*
$primarySuperHi : #f1f9ff;
$ff : 'Open Sans', sans-serif;
$bg : #000;

$green : #04d191;
$grey: #949494;
$orange: #fb8825;
$red: #d91541
*/


// WEBPACK FOOTER //
// ./src/assets/theme.js